/** Public site URL — set REACT_APP_SITE_URL at build time for production. */
export const SITE_URL =
  process.env.REACT_APP_SITE_URL || "https://the-daily-lingo.web.app";

export const SITE = {
  name: "The Daily Lingo",
  shortName: "Daily Lingo",
  title: "The Daily Lingo — Learn Languages with Daily News & Word Games",
  description:
    "Free daily language-learning app: read real news headlines translated into your target language, hover for English meanings, and play vocabulary puzzles including Wordle and crosswords. Supports Spanish, French, German, Chinese, and more.",
  keywords: [
    "language learning",
    "learn languages with news",
    "daily news for language learners",
    "vocabulary games",
    "wordle language learning",
    "crossword language practice",
    "Spanish news for learners",
    "French news for learners",
    "German news for learners",
    "bilingual news",
  ].join(", "),
  locale: "en_GB",
  twitterHandle: "",
  ogImagePath: "/logo512.png",
};

export function absoluteUrl(path = "/") {
  const base = SITE_URL.replace(/\/$/, "");
  const p = path.startsWith("/") ? path : `/${path}`;
  return `${base}${p}`;
}

export function buildStructuredData() {
  const url = SITE_URL;
  const logo = absoluteUrl(SITE.ogImagePath);

  return {
    "@context": "https://schema.org",
    "@graph": [
      {
        "@type": "WebSite",
        "@id": `${url}/#website`,
        url,
        name: SITE.name,
        description: SITE.description,
        inLanguage: "en-GB",
        publisher: { "@id": `${url}/#organization` },
      },
      {
        "@type": "Organization",
        "@id": `${url}/#organization`,
        name: SITE.name,
        url,
        logo: {
          "@type": "ImageObject",
          url: logo,
        },
      },
      {
        "@type": "WebApplication",
        "@id": `${url}/#app`,
        name: SITE.name,
        url,
        description: SITE.description,
        applicationCategory: "EducationalApplication",
        operatingSystem: "Web",
        offers: {
          "@type": "Offer",
          price: "0",
          priceCurrency: "GBP",
        },
        featureList: [
          "Daily news articles translated into 18+ languages",
          "Hover-to-reveal English translations while reading",
          "Daily vocabulary Wordle-style puzzles",
          "Crossword puzzles from news vocabulary",
          "Archive of recent daily editions",
        ],
        inLanguage: ["en", "es", "fr", "de", "zh-Hans", "hi", "it", "pt", "ja", "ko"],
      },
      {
        "@type": "FAQPage",
        "@id": `${url}/#faq`,
        mainEntity: [
          {
            "@type": "Question",
            name: "What is The Daily Lingo?",
            acceptedAnswer: {
              "@type": "Answer",
              text: "The Daily Lingo is a free web app that helps you learn a language using real daily news. Articles are translated into your chosen language; hover any phrase to see the original English. Daily word games reinforce vocabulary from the news.",
            },
          },
          {
            "@type": "Question",
            name: "Which languages can I learn?",
            acceptedAnswer: {
              "@type": "Answer",
              text: "You can study many languages including Spanish, French, German, Chinese (Simplified), Hindi, Italian, Portuguese, Japanese, Korean, Arabic, Dutch, Polish, Russian, Swedish, Turkish, Ukrainian, Vietnamese, and more.",
            },
          },
          {
            "@type": "Question",
            name: "How often is new content published?",
            acceptedAnswer: {
              "@type": "Answer",
              text: "A new edition of news articles and vocabulary games is prepared overnight (Europe/London time) every day. Recent editions remain available for up to seven days.",
            },
          },
        ],
      },
    ],
  };
}
